import { render, staticRenderFns } from "./AccProductTemplateCreateForm.vue?vue&type=template&id=92dc6b7a"
import script from "./AccProductTemplateCreateForm.vue?vue&type=script&lang=js"
export * from "./AccProductTemplateCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports